import { render, staticRenderFns } from "./part1.vue?vue&type=template&id=f4fb7d5a&"
import script from "./part1.vue?vue&type=script&lang=js&"
export * from "./part1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports